<template>
  <right-banner-template :title="title">
    <div class="foundation-content" v-for="(htr, i) in $store.getters['about/finalHistory']" :key="i">
      <p v-html="htr.content"></p>
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['title']
}
</script>

<style scoped>
  .foundation-content p {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 1.5;
  }

  .foundation-content p br {
    margin-bottom: 10px;
  }
</style>
